var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"width":_vm.width,"height":_vm.height,"fill":"none","viewBox":"0 0 19 19","xmlns":"http://www.w3.org/2000/svg"}},[_c('circle',{attrs:{"cx":"9.5","cy":"9.5","r":"8.5","stroke":_vm.color}}),_c('path',{attrs:{"d":"M14.6139 9.4047L4.19685 9.40486","stroke":_vm.color,"stroke-width":"1.17067"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }